/**
 * Kestrel's `darkMode` setting (ihf-root DarkModeConstant). The user model keeps the raw number;
 * this names it. Kestrel renders an unset value as auto-detect (kestrel app/base/mui).
 */
class Type {

	public static AUTO = new Type(1, "Auto-detect");
	public static LIGHT = new Type(2, "Light Mode");
	public static DARK = new Type(3, "Dark Mode");

	private constructor(
		public readonly id: 1 | 2 | 3,
		public readonly label: string,
	) {
	}

	public get auto() {
		return this === Type.AUTO;
	}

	public get light() {
		return this === Type.LIGHT;
	}

	public get dark() {
		return this === Type.DARK;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: number) {
		return this.values().find(value => value.id === id);
	}

}

export { Type as DarkMode };
